module.exports = __webpack_public_path__ + "img/21.128c125.png";